module.exports = __webpack_public_path__ + "static/media/shotaro-1.jpeg";